import React, { useEffect, useState } from 'react';
import './style.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import { createFreePayment, createPayment, getEmployeePlan, getSubscriptionList } from '../../services/subscriptions.service';
import { ButtonGroup } from "react-bootstrap";
import Button from 'react-bootstrap/Button'
import { toast } from 'react-toastify';
import { AxiosError } from 'axios';
import { all_routes } from '../router/all_routes';
import PartnerList from './PartnerList/PartnerList';


export default function Subscription() {
  const [subscriptionList, setSubscriptionList] = useState<any[]>([]);
  const [plansList, setplanList] = useState<any[]>([]);
  const location = useLocation();
  const [authToken, setAuthToken] = useState("");
  const [selectedPlan, setSelectedPlan] = useState("Starter");
  const [loading, setLoading] = useState(false);
  const [selectedPlanId, setSelectedPlanId] = useState("-1");
  const navigate = useNavigate();
  const route = all_routes;
  const [isPlansLoading, setIsPlansLoading] = useState(true);   // for plans API

  // Save token SYNCHRONOUSLY before any useEffect runs
  // This ensures Header's useEffect sees the token and doesn't redirect to login
  // Always overwrite with URL token (it's the fresh token from mobile app)
  const queryParams = new URLSearchParams(location.search);
  const urlToken = queryParams.get("token");
  if (urlToken) {
    localStorage.setItem("token", urlToken);
  }

  const handlePlanChange = (plan: any) => {
    let array = []
    array.push(plan)
    setSubscriptionList(array)
    setSelectedPlan(plan.name)
  };

  const onPayment = async (item: any) => {
    let partners: any = []
    if (item.partnersDetails.length > 0) {
      item.partnersDetails.forEach((data: any) => {
        partners.push(data._id)
      })
    }

    let payload = {
      subcriptionId: item._id,
      amount: item.price,
      name: item.name,
      description: item.description,
      partners: partners,
      subscriptionId: item._id,
      packageId: item.packageId
    };

    try {
      setLoading(true);

      if (payload?.amount == 0) {
        const result = await createFreePayment(payload);
        setLoading(false)
        navigate(`${route.subscriptionSuccess}`);
      }
      else {
        const result = await createPayment(payload);
        if (result.status == 200) {
          let client_secret = result?.data?.data?.client_secret
          let publice_key = "egy_pk_live_WgJvanqlfXqbWdkF4rYG27W9bPYUSc7r";
          

          let url = `https://accept.paymob.com/unifiedcheckout/?publicKey=${publice_key}&clientSecret=${client_secret}`;
          window.location.href = url
          setLoading(false)
        }
      }
    } catch (error) {
      if (error instanceof AxiosError) {
        setLoading(false)
        toast.error(error.response?.data?.responseMessage)
      }
    }
  }

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get("token");

    if (token) {
      setAuthToken(token);
      localStorage.setItem("token", token);
    }

    getSubscriptions();
    getSelectedPlan()
  }, [location]);

  const getSubscriptions = async () => {
    try {
      setIsPlansLoading(true); // start loading

      const result = await getSubscriptionList();
      if (Array.isArray(result?.data?.data) && result?.data?.data?.length > 0) {
        let array = []
        array.push(result?.data?.data[0])
        setSelectedPlan(result?.data?.data[0].name)
        setSubscriptionList(array)
        setplanList(result?.data?.data)
      }
      setIsPlansLoading(false); // stop loading
    } catch (error) {
      console.error("Error fetching subscriptions:", error);
      setIsPlansLoading(false); // stop loading
    }
  };

  const getSelectedPlan = async () => {
    try {
      let result = await getEmployeePlan();
      if (result?.data?.data[0]?.subscriptionDetails) {
        setSelectedPlanId(result?.data?.data[0]?.subscriptionDetails?._id)
      }
    } catch (error) {
      console.error("Error fetching subscriptions:", error);
    }
  };

  const currentPlan = subscriptionList?.[0];

  return (
    <div className="subscription-page-wrapper">
      <div className="subscription-content">
        <div className="container py-4">
          <div className="row justify-content-center flex-column align-items-center">
            {plansList && plansList.length > 0 && (
              <ButtonGroup aria-label="Plan Selector" className="plan-selector">
                {plansList.map((plan: any) => (
                  <Button
                    key={plan._id || plan.name}
                    variant={selectedPlan === plan.name ? "dark" : "outline-dark"}
                    className={`plan-button ${selectedPlan === plan.name ? "active-plan" : ""
                      }`}
                    onClick={() => handlePlanChange(plan)}
                  >
                    {plan.name}
                  </Button>
                ))}
              </ButtonGroup>
            )}
            {subscriptionList &&
              subscriptionList.length > 0 &&
              subscriptionList.map((item: any, index: number) => {
                return (
                <div className="planDetail col-md-6 col-lg-4" key={index}>
                  <div className="card shadow-sm rounded-4 border-0">
                    <div className="card-body p-3">
                      <div className="d-flex gap-3 align-items-center mb-3">
                        <div className="">
                          <img
                            src="/assets/img/paperPlane.png"
                            alt="paperPlane"
                          />
                        </div>
                        <div className="d-flex flex-column align-items-start">
                          <h6 className="text-muted">
                            <strong>EGP {item?.price}</strong>
                            <span>/ Per month</span>
                          </h6>
                        </div>
                      </div>
                      <p className="get">Get access to</p>

                      <ul className="list-unstyled custom-bullet-list">
                        {item.planDescription1 && <li>{item.planDescription1}</li>}
                        {item.planDescription2 && <li>{item.planDescription2}</li>}
                        {item.planDescription3 && <li>{item.planDescription3}</li>}
                      </ul>

                      {/* Partner List */}
                      <PartnerList 
                        partners={item.partnersDetails || []} 
                        isLoading={isPlansLoading}
                      />

                      {item._id === selectedPlanId && (
                        <div className="content-center">
                          <div className="active-plan-label">
                            <span className="check-icon">✔</span> Active plan
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                );
              })}
            {
              !isPlansLoading &&
              subscriptionList?.length == 0 &&
              plansList?.length == 0 &&
              (
                <div className="centered-message">
                  No plans has been assigned to this company. Please contact support for assistance.
                </div>
              )
            }
          </div>
        </div>
      </div>
      
      {/* Fixed bottom button */}
      {currentPlan && currentPlan._id !== selectedPlanId && (
        <div className="fixed-bottom-button">
          <div className="container">
            <button
              type="button"
              className="custom-btn w-100"
              onClick={() => onPayment(currentPlan)}
              disabled={loading}
            >
              {loading ? (
                <Spinner animation="border" size="sm" role="status">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              ) : (
                <>Go with this plan <span className="arrow">→</span></>
              )}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
